import { render, staticRenderFns } from "./cedis.vue?vue&type=template&id=1e8a8f3e&scoped=true"
import script from "./cedis.vue?vue&type=script&lang=js"
export * from "./cedis.vue?vue&type=script&lang=js"
import style0 from "./cedis.vue?vue&type=style&index=0&id=1e8a8f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8a8f3e",
  null
  
)

export default component.exports